module.exports = __webpack_public_path__ + "img/facebook (1).144ca770.svg";